import toast from "react-hot-toast";

//----------Handle-API-response-error----------
export const elseMessage = (res) => {
    const errorMessage = res?.data?.message || res?.response?.data?.message || res?.message || "Something went wrong.";
    toast.error(errorMessage, { id: "error" });
    // console.log("elseBlock:", errorMessage);
}

//----------Handle-API-catch-error----------
export const catchMessage = (err) => {
    const errorMessage = err?.response?.data?.message || err?.message || "Network error occurred.";
    // toast.error(errorMessage, { id: "error" });
    console.log("catchBlock:", errorMessage);
}
//----------Handle-API-response-success----------
export const successMessage = (res) => {
    const successMessage = res?.data?.message || res?.message || "successfully"
    toast.success(successMessage, { id: "error" })
}



